import { useMutation } from "@tanstack/react-query";
import { API_ROUTES } from "../../constants";
import { apiClient } from "./apiClient";
import type { ChatSession } from "./types";

/**
 * Hook to create a new chat session
 */
export const useCreateSession = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post<ChatSession>(
        API_ROUTES.omniSearch.chats,
        null,
        {
          params: {
            agent_name: "pulse",
          },
        }
      );
      return response.data;
    },
  });
};
